import { useState } from 'react'
import { useIntl } from '@/intl'

export const useTexts = () => {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    summarizeFutureMobileRoute: translate({
      id: 'form.drivers.view.labels.summarizeFutureMobileRoute',
    }),
    summarizeFutureMobileRouteHelper: translate({
      id: 'form.drivers.edit.fields.summarizeFutureMobileRoute.helper',
    }),
  }))

  return api
}
